import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import Link from '@/components/atoms/Link';
import { connect } from 'react-redux';
import withApiData from '../../services/withApiData';
import { colorPalette, textStyles, fadeIn } from '../../styles/styleGuide';
import UserAvatar from '../UserAvatar';
import { toBreakpoint } from '../../styles/breakpoints';
import truncateText from '../../services/truncateText';
import { getResultData } from '../../redux/apiData';
import get from 'lodash.get';
var connectApiData = withApiData({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phase: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase', undefined)
  };
};
var GREETINGS = [{
  hour: 0,
  greeting: 'Goedenacht'
}, {
  hour: 6,
  greeting: 'Goedemorgen'
}, {
  hour: 12,
  greeting: 'Goedemiddag'
}, {
  hour: 18,
  greeting: 'Goedenavond'
}, {
  hour: 24,
  greeting: 'Goedenacht'
}];
var ProfileWidget = /*#__PURE__*/function (_Component) {
  function ProfileWidget() {
    var _this;
    _classCallCheck(this, ProfileWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProfileWidget, [].concat(args));
    _defineProperty(_this, "sortArray", function (profileData) {
      if (!profileData || !profileData.customer || !profileData.customer.users) return [];

      // We want to order the array of users, so the logged in user is first, then the other users in the household.
      return profileData.customer.users.sort(function (user) {
        return user.email === profileData.email ? 0 : 1;
      });
    });
    return _this;
  }
  _inherits(ProfileWidget, _Component);
  return _createClass(ProfileWidget, [{
    key: "getGreeting",
    value: function getGreeting(hours) {
      var timeFrame = GREETINGS.find(function (time) {
        return time.hour === hours || time.hour < hours && time.hour > hours - 6;
      });
      return timeFrame ? timeFrame.greeting : 'Goedendag';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        phase = _this$props.phase,
        match = _this$props.match,
        profile = _this$props.profile,
        isSmall = _this$props.isSmall,
        router = _this$props.router;
      var projectSlug = match.params.projectSlug;
      var profileData = profile.data;
      var date = new Date();
      var hours = date.getHours();
      var imageUrl = get(profileData, 'customer.customerImage') ? get(profileData, 'customer.customerImage') : get(profileData, 'image', undefined);
      var name = get(profileData, 'customer.customerName') ? get(profileData, 'customer.customerName') : get(profileData, 'name', undefined);
      return profileData ? __jsx(Container, {
        isSmall: isSmall,
        "data-e2e-profile-widget": true,
        "data-e2e-profile-widget-small": isSmall,
        "data-id": "dashboard_ProfileWidget_Container"
      }, __jsx(Top, {
        small: isSmall,
        "data-id": "dashboard_ProfileWidget_Top"
      }, __jsx(UserAvatarContainer, {
        onClick: function onClick() {
          return router === null || router === void 0 ? void 0 : router.push("/".concat(String(projectSlug), "/closed/profiel"));
        },
        "data-id": "dashboard_ProfileWidget_UserAvatarContainer"
      }, __jsx(UserAvatar, {
        phase: phase,
        size: "xlarge",
        mode: "imageLoader",
        imageUrl: imageUrl,
        name: name,
        "data-id": "dashboard_ProfileWidget_UserAvatar"
      })), __jsx(Greeting, {
        "data-id": "dashboard_ProfileWidget_Greeting"
      }, this.getGreeting(hours), " ", name), phase !== 'cj1' && __jsx(Fragment, null, this.sortArray(profileData).map(function (user, index) {
        return index < 2 && __jsx(CustomerUsers, {
          key: index,
          "data-id": "dashboard_ProfileWidget_CustomerUsers"
        }, __jsx(UserAvatar, {
          size: "xsmall",
          mode: "imageLoader",
          imageUrl: "",
          name: user.name,
          "data-id": "dashboard_ProfileWidget_UserAvatar"
        }), __jsx("span", {
          "data-id": "dashboard_ProfileWidget_span"
        }, user.name));
      }), profileData && profileData.customer && profileData.customer.users.length > 2 && __jsx(ExtraUsers, {
        "data-id": "dashboard_ProfileWidget_ExtraUsers"
      }, "+", profileData.customer.users.length - 2, ' ', profileData.customer.users.length - 2 > 1 ? 'accounts' : 'account', " gekoppeld"))), !isSmall && __jsx(Text, {
        "data-id": "dashboard_ProfileWidget_Text"
      }, ((phase === 'cj2' || phase === 'cj3') && profileData.customer && !profileData.customer.bio || phase === 'cj1') && __jsx("div", {
        "data-id": "dashboard_ProfileWidget_div"
      }, "Het is belangrijk je persoonlijke gegevens up to date te houden."), (phase === 'cj2' || phase === 'cj3') && profileData.customer && profileData.customer.bio && truncateText(profileData.customer.bio, 180), __jsx(Link, {
        href: "/".concat(String(match.params.projectSlug), "/closed/profiel"),
        "data-id": "dashboard_ProfileWidget_Link"
      }, "Profiel beheren")), isSmall && __jsx(Text, {
        "data-id": "dashboard_ProfileWidget_Text"
      }, phase !== 'cj1' && profileData.customer && profileData.customer.bio && profileData.customer.bio)) : null;
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps)(ProfileWidget)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  align-self: flex-start;\n  justify-content: space-between;\n  background-color: white;\n  margin-top: ", ";\n  height: ", ";\n  padding-left: 20rem;\n  padding-right: 20rem;\n  padding-bottom: 20rem;\n  opacity: 0;\n  animation: ", " 0.25s ease-in;\n  animation-fill-mode: forwards;\n\n  ", " @media all and (max-width: 969px) {\n    height: ", ";\n  }\n"])), function (props) {
  return !props.isSmall ? '-60rem' : '0rem';
}, function (props) {
  return !props.isSmall ? '466rem' : 'auto';
}, fadeIn, toBreakpoint.xl(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))), function (props) {
  return !props.isSmall ? '386rem' : 'auto';
});
var ExtraUsers = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-top: 15rem;\n  text-align: center;\n"])), textStyles.caption, colorPalette.textGrey);
var CustomerUsers = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  font-weight: bold;\n  color: ", ";\n  margin-top: 12rem;\n  justify-content: center;\n  max-width: 280rem;\n\n  > div {\n    margin-right: 8rem;\n  }\n\n  > span {\n    max-width: 240rem;\n    word-wrap: break-word;\n    text-align: center;\n  }\n"])), textStyles.standardText, colorPalette.textGrey);
var Top = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: ", "rem;\n"])), function (props) {
  return props.small ? 20 : 0;
});
var Text = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  color: ", ";\n  width: 100%;\n\n  > a {\n    align-self: flex-start;\n    margin: 6rem auto 0 auto;\n    cursor: pointer;\n    color: ", ";\n    text-decoration: none;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n"])), textStyles.caption, colorPalette.textGrey, colorPalette.blue, colorPalette.darkBlue, colorPalette.darkBlue);
var Greeting = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-top: 18rem;\n  text-align: center;\n  max-width: 280rem;\n  word-wrap: break-word;\n  margin-bottom: 10rem;\n"])), textStyles.title, colorPalette.orange);
var UserAvatarContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-top: -60rem;\n  &:hover {\n    cursor: pointer;\n  }\n"])));